module.exports = __webpack_public_path__ + "img/ic-search.c6a0effb.svg";